import { ROUTES_EVENT, ROUTES_EVENT_ATTENDANCE, ROUTES_EVENT_OVERVIEW } from '@/constants/routes';

export default {
    path: '/event',
    name: ROUTES_EVENT,
    component: () => import(/*webpackChunkName: 'event'*/ '@/views/Event.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/event/:sessionId',
            name: ROUTES_EVENT_OVERVIEW,
            component: () => import(/*webpackChunkName: 'event'*/ '@/components/event/EventOverview.vue')
        },
        {
            path: '/event/attendance/:sessionId',
            name: ROUTES_EVENT_ATTENDANCE,
            component: () => import(/*webpackChunkName: 'event'*/ '@/components/session/attendance/Attendance.vue')
        }
    ]
};
